<template>
   <v-app id="inspire">
      <navigationDrawer id="nav-content" :drawer="drawer" />
      <router-view />
  </v-app>
</template>

<script>
import navigationDrawer from '@/components/elements/navigationDrawer.vue'

export default {
   name: 'App',
   metaInfo() {
      return { 
         metaInfo: {
            title: 'Packet Zaragoza material d´embalatge',
            titleTemplate: '%s | Packet Zaragoza material d´embalatge'
         },
            title: 'Packet Zaragoza material de embalatge',
      }
   },
   components: {
      navigationDrawer,
   },
   props: {
      source: String,
   },
   data: () => ({
      drawer: null,
      shrinkOnScroll: null
   }),
   methods: {
      stop: function () {
         event.$emit('drawer', this.drawer);
      },
  }
}

</script>

<style lang="scss">

   .color-gradient-1 {
      background: linear-gradient(45deg, #3568d4, #6798ff);
   }
   .v-toolbar--collapsed {
      #logoText {
         font-size: 11px !important;
         line-height: 11px !important;
      }
   }
   .v-content {
      padding: 0 !important;
   }

</style>
